import styled from "styled-components";

interface JoinHeaderProps {
  headerTitle: string;
}

const JoinHeaderNonBtn = ({ headerTitle }: JoinHeaderProps) => {
  return (
    <HeaderContainer>
      <div className="header-title">
        <p>{headerTitle}</p>
      </div>
    </HeaderContainer>
  );
};

export default JoinHeaderNonBtn;

const HeaderContainer = styled.header`
  height: 5.6rem;
  display: grid;
  align-items: center;
  position: sticky;
  top: 0;
  left: 0;
  background-color: white;
  width: 100%;
  z-index: 99;
  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .header-title {
    display: flex;
    align-items: center;
    padding-left: 1.6rem;
    p {
      font-size: 1.6rem;
      font-weight: 500;
      letter-spacing: -0.06rem;
      line-height: 2rem;
      transform: translateY(1px);
    }
  }
`;
